import _ from "lodash";
import React from "react";
import classes from "./TimePicker.scss";
import { TimePicker as DSTimePicker } from "@toddle-edu/ds-web";
import { WarningTriangleFilled } from "@toddle-edu/ds-icons";

const TimePicker = props => {
  const { timeError } = props;

  return (
    <div className={classes.timeContainer}>
      <DSTimePicker {...props} hasError={!_.isEmpty(timeError)} />
      {!_.isEmpty(timeError) ? (
        <span className={classes.timeErrorContainer}>
          <WarningTriangleFilled
            size="xxx-small"
            variant="critical"
            className={classes.timeErrorIcon}
          />
          <span>{timeError}</span>
        </span>
      ) : null}
    </div>
  );
};

export default TimePicker;
